import { Skeleton } from "antd";
import React from "react";

const Loading: React.FC<{
  style?: React.CSSProperties;
}> = ({ style }) => (
  <Skeleton style={{ margin: "24px 40px", height: "60vh", ...style }} active />
);

export default Loading;
